export default "<div class=\"tree\">\n    <app-tree [tree]=\"tree\" [params]=\"params\"></app-tree>\n</div>"